module.exports = __webpack_public_path__ + "h5/img/head6.73e6d08e.png";